// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1qsv1","footer":"ReportModalFilter_footer__2h4oM"};